import URI from "urijs";

export default () => {
  return new URI(window.location.href).normalizePath();
};
